import {
  IAddUpdateRiderManagementPageState,
  ICreateRiderRequestPayload,
  ICreateUpdateRiderRequestPayload,
  IRiderManagementNormalized,
} from "../interfaces/riderManagement.interface";
import {
  ICreateUpdateRiderManagementUserNormalizedReq,
  IMultiSelectOption,
  IPlanCreationState,
} from "interfaces/Index";
import { PAGE_LENGTH } from "config/constants";

export const normalizeRiderManagementUserCreatePayload = (
  req: IAddUpdateRiderManagementPageState
): ICreateUpdateRiderRequestPayload => {
  return {
    id: req.id,
    userId: req.userId,
    title: req.title,
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    status: req.status === true ? "ACTIVE" : "INACTIVE",
    password: req.password,
    confirmPassword: req.confirmPassword,
    nationalId: req.cnic,
    email: req.email,
    jobType: req.jobType.map((item) => item.value),
    subType: req.subType ? req.subType.key : "",
    warehouseId: req.warehouseId,
  };
};

export const normalizeFetchRiderManagementUserResponse = (
  res: Array<IRiderManagementNormalized>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === PAGE_LENGTH ? pagination : false,
    isPaginatedRes,
  };
  payload.riderManagementData = res.map((riderManagement) => {
    return {
      userId: riderManagement.userId,
      fullName: riderManagement.fullName,
      phoneNumber: riderManagement.phoneNumber,
      status: riderManagement.status,
      title: riderManagement.title,
      jobType: riderManagement.jobType,
      subType: riderManagement.subType,
      warehouseId: riderManagement.warehouseId,
    };
  });
  return payload;
};

export const normalizeRiderManagementUserUpdatePayload = (
  req: IAddUpdateRiderManagementPageState
): ICreateUpdateRiderManagementUserNormalizedReq => {
  const subType = req.subType ? req.subType.key : "BAZAAR";
  const payload: ICreateUpdateRiderManagementUserNormalizedReq = {
    id: req.id,
    userId: req.userId,
    fullName: req.fullName,
    title: getRiderTitle(subType, req.jobType),
    nationalId: req.cnic,
    email: req.email,
    status: req.status === true ? "ACTIVE" : "INACTIVE",
    phoneNumber: req.phoneNumber,
    jobType: req.jobType.map((item) => item.value),
    subType: subType,
    warehouseId: req.warehouseId,
  };
  return payload;
};

export const normalizeCreateRiderPayload = (
  req: IAddUpdateRiderManagementPageState
): ICreateRiderRequestPayload => {
  const subType = req.subType ? req.subType.key : "BAZAAR";
  return {
    userId: req.userId,
    title: getRiderTitle(subType, req.jobType),
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    status: req.status === true ? "ACTIVE" : "INACTIVE",
    jobType: req.jobType.map((item) => item.value),
    subType: subType,
    warehouseId: req.warehouseId,
  };
};

export const getRiderTitle = (
  subType: string,
  jobType: IMultiSelectOption[]
) => {
  const jobTypeList = jobType.map((item) => item.value);
  return appendSubTypeWithJobTypeForRiderTitle(subType, jobTypeList);
};

export const appendSubTypeWithJobTypeForRiderTitle = (
  subType: string,
  jobTypes: string[]
) => {
  const allValues = [subType].concat(jobTypes || []);
  return `${allValues.join("_")}`;
};

export const normalizeLocusCsvPayload = (planCreation: IPlanCreationState) => {
  const expandedPlanTypes = planCreation.planType.flatMap(({ id }) => {
    if (id === "RETURN_PICKUP") {
      return ["DROP", "RETURN"];
    }
    return id;
  });

  return {
    warehouseId: planCreation.warehouseId.id,
    targetDate: (() => {
      const date = new Date(planCreation.targetDate);
      date.setUTCHours(0, 0, 0, 0);
      return date.getTime().toString();
    })(),
    planType: expandedPlanTypes,
    customerChannel: planCreation.customerChannel.map(({ id }) => id),
    storeType: planCreation.storeType.map(({ id }) => id),
  };
};
